<template>
    <div class="relative" :class="{ 'pointer-events-none': disabled }">
        <div class="border-b lg:mx-0 lg:px-0"
            :class="{ 'border-gray-400/50': small && !visible }">
            <button class="flex w-full justify-between items-center"
                    @click="toggle"
                    :class="[{ 'opacity-50': disabled }, small ? 'pt-6 pb-2 text-md' : 'text-xl py-8 font-bold lg:text-2xl']">
                <slot name="title" :open="visible">
                    <span>{{ title }}</span>
                </slot>
                <lz-icon v-if="small"
                         name="accordion-chevron"
                         :class="[visible ? (small ? 'rotate-0' : '-rotate-90') : (small ? 'rotate-180' : 'rotate-90')]"
                         class="shrink-0 transition-transform fill-current h-4 w-4 stroke-current" />
                <lz-icon v-else
                         :name="visible ? 'minus' : 'plus'"
                         class="shrink-0 transition-transform fill-current h-6 w-6" />
            </button>
            <collapse-transition v-show="visible">
                <div :class="{ 'pb-8': !small }">
                    <slot :ready="ready" />
                </div>
            </collapse-transition>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, withDefaults, defineEmits, defineProps, onMounted } from 'vue';
import events from '@/events';
import LzIcon from './LzIcon.vue';

const props = withDefaults(defineProps<{
    title?: string;
    group?: string;
    open?: boolean;
    disabled?: boolean;
    small?: boolean;
}>(), {
    title: '',
    group: '',
    open: false,
    disabled: false,
    small: false
});
const emit = defineEmits<{
    (e: 'toggle', open: boolean): void
}>();
const visible = ref(props.open);
const ready = ref(false);

events.$on('accordion-open', onAccordionOpened);

onMounted(() => {
    ready.value = true;
});

function onAccordionOpened(group: string) {
    if (!props.group || props.group === '') {
        return;
    }
    if (props.group === group) {
        visible.value = false;
    }
}

function toggle() {
    if (!visible.value) {
        events.$emit('accordion-open', props.group);
    }
    visible.value = !visible.value;
    emit('toggle', visible.value);
}
</script>
